<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4.09482 9.12128L16.0002 19.3239L27.9055 9.12128M24.4442 24.8866H7.55615C5.34682 24.8866 3.55615 23.0959 3.55615 20.8866V11.1133C3.55615 8.90395 5.34682 7.11328 7.55615 7.11328H24.4455C26.6548 7.11328 28.4455 8.90395 28.4455 11.1133V20.8879C28.4442 23.0959 26.6535 24.8866 24.4442 24.8866Z"
        :stroke="color" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'MessageIcon',
  props: {
    color: {
      type: String,
      default: '#6DB8FF',
    },
  },
};
</script>